import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable, catchError, switchMap, throwError } from "rxjs";
import { SharedActions } from "./actions";

@Injectable()
export class CorrelIdInterceptor implements HttpInterceptor {

    constructor(private store: Store) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const modifiedReq = req.clone({
          setHeaders: {
            'Schwab-Client-AppId': 'AD00007177'
          }
        })

        const correlId = modifiedReq?.headers?.get('Schwab-Client-CorrelId');
        if (correlId) {
          this.store.dispatch(SharedActions.updateCorrelationId({correlationId: correlId, serviceCallUrl: req.url}))
        }

        return next.handle(modifiedReq)
    }
}